/**
 * SXRemoteSource
 * 
 * 用于下载素材到 FS 中
 * 
 */
export default class SXRemoteSource {

    /**
     * 创建一个SXRemoteSource
     * 
     * @param url 下载链接
     * @param path, 本地保存目录
     * 
    */
   constructor(url, path) {
        this.FS = window["FS"];
        this.id = "source-" + this.uuid();
        this.url = url;
        this.localPath= path;

        this.isDir = false;
        this.localFilePaths = []; 
        this.refCount = 1; 
        this.isLoading = false;
        this.isLoaded = false;
    }


    get(url){
        return new Promise((resolve) => {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true);
            xhr.responseType = "arraybuffer"
            xhr.onreadystatechange = function () {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        resolve({status : true, response : this.response});
                    } else {
                        resolve({status : false, response : this.response});
                    }
                }
            }
            xhr.send();
        });
    }

    /**
     * 开始加载资源
     * 
     * */ 
    load() {
        if (this.isLoading || this.isLoaded) {
            return new Promise( (resolve) => {
                    resolve({status : this.isLoaded, isLoading : this.isLoading, isLoaded: this.isLoaded, path : this.localPath});
                }
            )
        }

        this.isLoading = true;
        if (this.extname(this.url) == "") {
            console.warn("invalid source " + this.path + ":" + this.url);
            this.isLoading = false;

            return new Promise( (resolve) => {
                    resolve({status : false, isLoading : this.isLoading, isLoaded: this.isLoaded, path : this.localPath});
                }
            )
        }
   
        return this.get(this.url).then( ret => {
            if (ret.status == false) {
                return {status : false,isLoading : this.isLoading, isLoaded: this.isLoaded, path : this.localPath};
            } else {
                let res = this.loadFile(ret.response, this.localPath, 0);
                return {status : res, isLoading : this.isLoading, isLoaded: this.isLoaded, path : this.localPath};
            }
        });
    }

    /**
     * 加载文件
     * @param  url :string; 网络资源路径
     * @param  filePath :string; 内存文件路径 
     */
    loadFile(data, filePath, status) {
        
        if (status != 0) {
            console.error(`loading status ${this.type} ${filePath} : ${status}` );
        }

        if (status != 0) {
            this.isLoaded = false;
            this.isLoading = false;
            return false;
        }

        let isExist = this.isExistFilePath(filePath);
        if (isExist) return true;

        // 创建文件夹
        var dirPath = this.getDirPath(this.localPath);
        if (!this.isExistFilePath(dirPath)) {
            this.mkdirInToMemory(dirPath);
        }

        // 写入内存
        let ret = this.loadDataIntoMemory(filePath, data);
        if (ret.status) {
            this.localPath = filePath;
            this.isLoaded = true;
            this.isLoading = false;
            return true;
        } else {
            console.error("FS write file error :" + this.localPath + ", " + this.url);
        }

        return false;
    }


    /**
     *  向内存中写入文件
     * @param filePath string  内存路径
     * @param data ArrayBuffer对象
     * @return statusObj 
     *      msg : stirng;
     *      status : boolean;
    */
    loadDataIntoMemory(filePath, data) {
        let FS = this.FS;
        let statusObj = {
            msg: "ok",
            status: true
        };

        if (!filePath || !data) {
            statusObj.msg = "文件路径或数据不存在!";
            statusObj.status = false;
            return statusObj;
        }
        try {
            let uint8Data = new Uint8Array(data);
            FS.writeFile(filePath, uint8Data);
        } catch (err) {
            statusObj.msg = err.message;
            statusObj.status = false;
        }
        return statusObj;
    }

    /**
     * 获取目录
     * 
    */
   getDirPath(path) {
        var last = path.lastIndexOf("/");
        if (last > 0) {
            return path.substring(0, last + 1);
        }

        return "/";
    }

    /**
     * 判断内存文件是否存在
     * @param  filePath 
    */
    isExistFilePath(filePath) {
        let FS = this.FS;
        try {
            FS.stat(filePath);
            return true;
        } catch (error) {
            return false;
        }
    }

    /**
      * 清除当前source对象,写入内存的资源
      * @param  fileList:<string>Array
      *  当前的localFilePaths数组
   */
    clear(fileList) {
        let FS = this.FS;
        fileList = fileList.reverse();
        for (const key in fileList) {
            const path = fileList[key];
            let isExist = this.isExistFilePath(path);
            if (!isExist) continue;
            let fileInfo = FS.stat(path);
            if (FS.isFile(fileInfo.mode)) {
                FS.unlink(path);
            }
            if (FS.isDir(fileInfo.mode)) {
                FS.rmdir(path);
            }
        }
        this.localFilePaths = [];
    }

    /**
    * 创建内存文件夹
    * @param filePath : string;    
    */
    mkdirInToMemory(dirPath) {
        let FS = this.FS;
        let arrpaths = dirPath.split('/');
        if (arrpaths.length === 0) {
            return;
        }
        let targetPath = "";
        for (let j = 0; j < arrpaths.length - 1; j++) {
            if (arrpaths[j] === "") continue;
            targetPath = targetPath + "/" + arrpaths[j];
            try {
                FS.stat(targetPath);
            } catch (err) {
                FS.mkdir(targetPath, 0o777);
            };
        }
    }


    // 从 FS 中删除文件, 不可恢复
    unload() {
        this.isLoaded = false;
        this.isLoading = false;
        this.refCount = 0;

        let isExist = this.isExistFilePath(this.localPath);
        if (!isExist) {
            return;
        } 
        let FS = this.FS;
        let path = this.localPath;
        let fileInfo = FS.stat(path);
        if (FS.isFile(fileInfo.mode)) {
            console.log("remove : " + path);
            FS.unlink(path);
        }
        if (FS.isDir(fileInfo.mode)) {
            this.clear(this.localFilePaths);
            console.log("remove : " + path);
        }
    }

    uuid() {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
    
        var uuid = s.join("");
        return uuid;
    }
    

    extname(filename) {
        if (!filename || typeof filename != 'string') {
            return "";
        };
        let a = filename.split('').reverse().join('');
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('');
        return b
    };


    isVideo(ext) {
        let exts = ["mp4", "mov", "mts", "mxf"];
        for(let i = 0; i < exts.length; i++){
            if (ext == exts[i]) {
                return true;
            }
        }

        return false;
    } 

    isImage(ext) {
        let exts = ["png", "jpeg", "jpg", "gif"];
        for(let i = 0; i < exts.length; i++){
            if (ext == exts[i]) {
                return true;
            }
        }

        return false;
    }


    isLoading() {
        return this.isLoading;
    }

    isLoaded() {
        return this.isLoaded;
    }

    getType() {
        return this.type;
    }

    getLocalPath() {
        return this.localPath;
    }
}

// module.exports = SXRemoteSource;
